import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import reducer from "./store/reducers/index";
import createSagaMiddleWare from "redux-saga";
import history from "./utils/history";
import searchSuppWeb from "./store/sagas/SearchSaga";

import { watchDashboard } from "./store/sagas/";

const sagaMiddleWare = createSagaMiddleWare();
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  reducer,
  composeEnhancer(applyMiddleware(sagaMiddleWare))
);
// ,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
sagaMiddleWare.run(searchSuppWeb);
sagaMiddleWare.run(watchDashboard); //saga imported

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
